import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { useUniboxColors } from "../../useUniboxColors";

/**
 * Botón de icono unificado (barra global de selección + visor de mensaje).
 * Siempre cuadrado con esquinas redondeadas (c.radius).
 */
export default function ToolbarIconButton({
  title,
  onClick,
  icon,
  variant = "default",
  active = false,
  disabled = false,
  size = 34,
}) {
  const c = useUniboxColors();

  const resolvedVariant = active ? "primary" : variant;

  const styles = {
    default: {
      bgcolor: c.toolbarBtn,
      color: c.textMuted,
      border: `1px solid ${c.border}`,
      hoverBg: c.toolbarBtnHover,
      hoverColor: c.accent,
      hoverBorder: c.accentBorder,
    },
    primary: {
      bgcolor: c.toolbarBtnActive,
      color: c.accent,
      border: `1px solid ${c.accentBorder}`,
      hoverBg: c.accentSoft,
      hoverColor: c.accent,
      hoverBorder: c.selectedBorder,
    },
    danger: {
      bgcolor: c.isDark ? "rgba(248, 113, 113, 0.14)" : "#fef2f2",
      color: c.isDark ? "#fca5a5" : "#dc2626",
      border: `1px solid ${c.isDark ? "rgba(248, 113, 113, 0.4)" : "#fecaca"}`,
      hoverBg: c.isDark ? "rgba(248, 113, 113, 0.24)" : "#fee2e2",
      hoverColor: c.isDark ? "#fecaca" : "#b91c1c",
      hoverBorder: c.isDark ? "#f87171" : "#fca5a5",
    },
    read: {
      bgcolor: c.isDark ? "rgba(16, 185, 129, 0.16)" : "#ecfdf5",
      color: c.isDark ? "#6ee7b7" : "#059669",
      border: `1px solid ${c.isDark ? "rgba(16, 185, 129, 0.38)" : "#a7f3d0"}`,
      hoverBg: c.isDark ? "rgba(16, 185, 129, 0.28)" : "#d1fae5",
      hoverColor: c.isDark ? "#a7f3d0" : "#047857",
      hoverBorder: c.isDark ? "#34d399" : "#6ee7b7",
    },
    unread: {
      bgcolor: c.isDark ? "rgba(14, 165, 233, 0.16)" : "#e0f2fe",
      color: c.isDark ? "#7dd3fc" : "#0284c7",
      border: `1px solid ${c.isDark ? "rgba(14, 165, 233, 0.38)" : "#bae6fd"}`,
      hoverBg: c.isDark ? "rgba(14, 165, 233, 0.28)" : "#bae6fd",
      hoverColor: c.isDark ? "#bae6fd" : "#0369a1",
      hoverBorder: c.isDark ? "#38bdf8" : "#7dd3fc",
    },
  };

  const v = styles[resolvedVariant] || styles.default;

  return (
    <Tooltip title={title}>
      <span>
        <IconButton
          size="small"
          onClick={onClick}
          disabled={disabled}
          sx={{
            width: size,
            height: size,
            borderRadius: c.radius,
            bgcolor: v.bgcolor,
            color: v.color,
            border: v.border,
            transition: "all 0.15s ease",
            "&:hover": {
              bgcolor: v.hoverBg,
              color: v.hoverColor,
              borderColor: v.hoverBorder,
            },
            "&.Mui-disabled": {
              opacity: 0.45,
            },
          }}
        >
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  );
}
